var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddaudio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 9.00146C0.905877 10.925 1.8009 12.7463 3.32501 14.0821C4.84911 15.418 6.88353 16.1644 9.00041 16.1644C11.1173 16.1644 13.1517 15.418 14.6758 14.0821C16.1999 12.7463 17.0949 10.925 17.1727 9.00146",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00586 19.2474V16.4275",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1381 12.6643H8.87323C7.80196 12.6643 6.77456 12.2773 6.01705 11.5885C5.25955 10.8997 4.83398 9.96552 4.83398 8.99142V4.42551C4.83398 3.45141 5.25955 2.51721 6.01705 1.82841C6.77456 1.13962 7.80196 0.752625 8.87323 0.752625H9.14913C10.2204 0.752625 11.2478 1.13962 12.0053 1.82841C12.7628 2.51721 13.1884 3.45141 13.1884 4.42551V8.99142C13.1884 9.96552 12.7628 10.8997 12.0053 11.5885C11.2478 12.2773 10.2204 12.6643 9.14913 12.6643H9.1381Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddaudio);
export default __webpack_public_path__ + "static/media/addaudio.5aa7c17fabc45d73a141358b58b40ad1.svg";
export { ForwardRef as ReactComponent };